import { render, staticRenderFns } from "./vendor-add.vue?vue&type=template&id=3184f7f4&"
import script from "./vendor-add.vue?vue&type=script&lang=js&"
export * from "./vendor-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports